import { IStylingBorder, ISymbol } from "@kuika/kuika-cl-model";
import * as React from "react";
import { ColorPickerPositionHelper } from "../../../../shared/utility/color-picker-position-helper";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import { PropertyHelper } from "../../../../shared/utility/property-helper";
import KuikaButton from "../../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import { ColorPicker } from "../styling-panel/styling-color-picker";

export interface PropertyFormColorPickerPropertyState {
  propertyValue: string | undefined;
  isColorPickerActive: boolean;
}

export interface PropertyFormColorPickerPropertyProps {
  symbol: ISymbol;
  applyPropertyValueChanged: (value: any) => void;
  dontUseFixedPosition?: boolean;
  // Clear removes the value instead of writing white, so the component falls back to its default colour.
  clearsToEmpty?: boolean;
}

export class PropertyFormColorPickerProperty extends React.PureComponent<
  PropertyFormColorPickerPropertyProps,
  PropertyFormColorPickerPropertyState
> {
  propertyHelper: PropertyHelper;

  constructor(props) {
    super(props);
    this.propertyHelper = new PropertyHelper();
    this.state = {
      propertyValue: this.props.symbol.fixedValue,
      isColorPickerActive: false
    };
  }

  componentDidUpdate = (prevProps: PropertyFormColorPickerPropertyProps) => {
    if (prevProps === this.props) return;
    this.setState({ propertyValue: this.getPropertyValueFromProps() });
  };

  getPropertyValueFromProps = (): string | undefined => {
    return this.state.propertyValue;
  };

  applyPropertyValueChanged = (value: string) => {
    this.setState({ propertyValue: value });

    if (this.props.applyPropertyValueChanged) {
      this.props.applyPropertyValueChanged(value);
    }
  };

  toggleColorPicker = (event?: any, index?: number) => {
    this.setState({ isColorPickerActive: !this.state.isColorPickerActive });
    if (event) {
      if (typeof event.persist === "function") {
        event.persist();
      }
      ColorPickerPositionHelper.saveLastClickEvent(event);

      KMainFunctions.setColorTriggeredPickerPosition(event);
    }
  };

  closeColorPicker = () => {
    this.setState({ isColorPickerActive: false });
  };

  handleFillColorClear = (event: any) => {
    const clearedValue: string | undefined = this.props.clearsToEmpty ? undefined : "rgba(255, 255, 255, 1)";
    this.setState({ propertyValue: clearedValue });
    if (this.props.applyPropertyValueChanged) {
      this.props.applyPropertyValueChanged(clearedValue);
    }

    const tempObject = {} as IStylingBorder;
    tempObject.borderColor = undefined;
  };

  setColorPickerValue = (color: string) => {
    this.setState({ propertyValue: color }, () => this.props.applyPropertyValueChanged(this.state.propertyValue));
  };

  render() {
    const { propertyValue } = this.state;
    return (
      <>
        <div
          className="kuika_styleSection kuika_styling_typography_wrapper"
          style={{ flexDirection: "column", padding: "8px 2px", width: "100%" }}
        >
          <div style={{ display: "inherit" }}>
            <div style={{ marginRight: 5, marginLeft: 5 }}>
              <div
                style={{
                  width: 28,
                  height: 24,
                  borderRadius: "var(--radius-s)",
                  border: "2px solid var(--control-border)",
                  // No value: the styling panel's transparent checkerboard, not the panel showing through.
                  background:
                    this.state.propertyValue || "url(/images/styling-panel-icons/transparent.svg) center / cover",
                  textAlign: "right"
                }}
                onClick={(e) => this.toggleColorPicker(e)}
              >
                <div style={{ marginRight: 5, marginTop: 3 }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                    <g fill="none" fillRule="evenodd">
                      <path d="M0 0H14V14H0z" />
                      <path
                        fill="#ffffff"
                        // The checkerboard is light in both themes, so a white chevron would vanish on it.
                        style={this.state.propertyValue ? undefined : { fill: "var(--black)" }}
                        fillRule="nonzero"
                        d="M7.292 7.47l2.374-2.323c.258-.252.675-.252.933 0 .257.252.257.66 0 .912L7.73 8.863c-.243.238-.636.238-.879 0L3.985 6.06c-.258-.252-.258-.66 0-.912.257-.252.675-.252.932 0L7.292 7.47z"
                      />
                    </g>
                  </svg>
                </div>
              </div>
              <div
                className={`kuika_colorPicker ${this.props.dontUseFixedPosition ? "non-fixed-position" : ""}`}
                style={{
                  display: this.state.isColorPickerActive === true ? "block" : "none"
                }}
              >
                <ColorPicker
                  color={this.state.propertyValue}
                  onChange={(color) => this.setColorPickerValue(color)}
                  onCancel={() => this.closeColorPicker()}
                  isColorPickerActive={this.state.isColorPickerActive}
                  hideHeaderTabs={true}
                />
              </div>
            </div>
            <div>
              <span
                className="k_Regular-G1-Left"
                style={{
                  fontSize: "10px",
                  letterSpacing: "0.35px",
                  verticalAlign: "middle"
                }}
              >
                Color
              </span>
            </div>
            <div style={{ marginLeft: "auto" }}>
              <KuikaButton type="tertiary" color="neutral" isIcon onClick={(event) => this.handleFillColorClear(event)}>
                <KuikaSvg name="trash" width={24} height={24} />
              </KuikaButton>
            </div>
          </div>
        </div>
      </>
    );
  }
}
